import React from "react"
import { connect } from "react-redux"

import Alert from "@material-ui/lab/Alert"
import { Grid } from "@material-ui/core"
import { HashLink as Link } from "react-router-hash-link"

import { clearCart } from "../../redux/cart/cart.actions"
import api from "../../services/api"

import "./Success.scss"

class Success extends React.Component {
  state = {
    status: "processing", // processing | success | failed
  }

  async componentDidMount() {
    const params = new URLSearchParams(window.location.search)
    const sessionId = params.get("session_id")

    if (!sessionId) {
      this.setState({ status: "success" })

      // limpa apenas aqui (fallback sem session)
      localStorage.removeItem("userCart")
      localStorage.removeItem("voucher")
      this.props.clearCart()

      return
    }

    let attempts = 0

    const interval = setInterval(async () => {
      try {
        const res = await api.get(`/payment-status/${sessionId}`)

        if (res.data?.processed) {
          clearInterval(interval)

          this.setState({ status: "success" })

          // LIMPA CART SOMENTE NO SUCESSO
          localStorage.removeItem("userCart")
          localStorage.removeItem("voucher")
          this.props.clearCart()

          return
        }

        if (res.data?.failed) {
          clearInterval(interval)

          this.setState({ status: "failed" })

          // NÃO LIMPA CART → usuário pode tentar novamente
          return
        }
      } catch (err) {
        console.error("Payment status error:", err)

        clearInterval(interval)

        this.setState({ status: "failed" })
      }

      attempts++

      if (attempts > 10) {
        clearInterval(interval)

        this.setState({ status: "failed" })
      }
    }, 1000)
  }

  render() {
    const { status } = this.state

    return (
      <div className="container success">
        <Grid container spacing={4}>
          <Grid item xs={12}>
            {status === "processing" && (
              <Alert severity="info">
                We are confirming your purchase. Please wait a moment...
              </Alert>
            )}

            {status === "success" && (
              <Alert severity="success">
                Thank you for your purchase. Your access has been confirmed
                successfully.
              </Alert>
            )}

            {status === "failed" && (
              <Alert severity="error">
                We could not confirm your purchase automatically.
                <br />
                If the payment was completed, your order may still need a manual
                confirmation on our side.
                <br />
                Please contact us at{" "}
                <strong>bartira@headstartcourses.ie</strong> and include your
                name and purchase details so we can help you as soon as
                possible.
              </Alert>
            )}
          </Grid>

          <Grid item xs={12}>
            {status === "success" && (
              <Link className="btn-purple" to="/dashboard">
                Go to your dashboard
              </Link>
            )}

            {status === "failed" && (
              <a
                className="btn-purple"
                href="mailto:bartira@headstartcourses.ie"
              >
                Contact support
              </a>
            )}
          </Grid>
        </Grid>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  clearCart: () => dispatch(clearCart()),
})

export default connect(null, mapDispatchToProps)(Success)
